module.exports = __webpack_public_path__ + "static/coaches-cbc48aa08b06bfe0562531d0a06d31ad.jpg";